import { render, staticRenderFns } from "./VitalityMoneyStatus.vue?vue&type=template&id=3d3c7053&scoped=true"
import script from "./VitalityMoneyStatus.vue?vue&type=script&lang=js"
export * from "./VitalityMoneyStatus.vue?vue&type=script&lang=js"
import style0 from "./VitalityMoneyStatus.vue?vue&type=style&index=0&id=3d3c7053&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3c7053",
  null
  
)

export default component.exports